import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import ClearTwoToneIcon from '@mui/icons-material/ClearTwoTone';

interface FoodNoteDialogProps {
    restaurantOfferStore: RestaurantOfferStore,
}

const FoodNoteDialog: React.FC<FoodNoteDialogProps> = observer(({ restaurantOfferStore }) => {
    const { isFoodNoteDialogOpen, setIsFoodNoteDialogOpen, orderFoodRequest, onFoodNoteSave } = restaurantOfferStore;

    const [noteValue, setNoteValue] = useState<string>('');

    const handleOnClose = () => {
        setIsFoodNoteDialogOpen(false)
    }

    const handleOnSave = () => {
        var value = noteValue.trim() !== "" ? noteValue.trim() : null;
        onFoodNoteSave(value);
    }

    useEffect(() => {
        if (orderFoodRequest?.note) {
            setNoteValue(orderFoodRequest.note);
        }
        else {
            setNoteValue("");
        }
    }, [isFoodNoteDialogOpen])

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={isFoodNoteDialogOpen}
            onClose={handleOnClose}
        >
            <DialogContent>
                <Box mt={1}>
                    <TextField
                        label="Napomena"
                        autoFocus
                        fullWidth
                        value={noteValue}
                        onChange={(e) => setNoteValue(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end" onClick={() => setNoteValue("")}>
                                    <IconButton>
                                        <ClearTwoToneIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0 }}>
                <Button
                    size='small'
                    color='secondary'
                    onClick={handleOnClose}>
                    Odustani
                </Button>
                <Button
                    size='small'
                    color='secondary'
                    variant='contained'
                    type="submit"
                    onClick={handleOnSave}>
                    Spremi
                </Button>
            </DialogActions>
        </Dialog >
    );
})

export default FoodNoteDialog;